import React from 'react';

const DelegationHeader = ({ totalMembers }) => {
    return (
        <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center">
                <h2 
                    className="txt-main fw-bold m-0" 
                    style={{ fontSize: "1.1rem" }}
                >
                    Delegação
                </h2>
                
                {/* Link clicável com um tom de cinzento elegante */}
                <span 
                    style={{ 
                        fontSize: "0.85rem", 
                        color: "var(--gray-400)", 
                        cursor: "pointer", 
                        fontWeight: "600" 
                    }}
                >
                    Ver todos ({totalMembers})
                </span>
            </div>

            <div 
                className="mt-3 w-100" 
                style={{ 
                    height: "1px", 
                    backgroundColor: "var(--gray-200)" 
                }} 
            />
        </div>
    );
};

export default DelegationHeader;